export default [
    {
        path: '/department',
        meta: {
            authCode: "xcrm.manage.department"
        },
        component: (resolve) => require(['./DepartmentList.vue'], resolve),

    }
]



// WEBPACK FOOTER //
// ./src/modules/department/router.js